export const reportDataDangerousMedicine = {
  data: {
    rpp: '/COROTA/MedicineDangerous',
    pts: 1,
    fr: true,
    dn: '',
    rp: '',
  },
  dataDownloadPDF: {
    rpp: '/COROTA/MedicineDangerous',
    pts: 0,
    fmt: 2,
    dn: '',
    rp: '',
  },
  dataDownloadExcel: {
    dn: '',
    fmt: 3,
    pts: 0,
    rp: '',
    rpp: '/COROTA/MedicineDangerous',
  },
  dataRenderReport: {
    dl: false,
    dn: '',
    fmt: 2,
    htmf: false,
    pts: 0,
    rp: '',
    rpp: '/COROTA/MedicineDangerous',
    z: 100,
  },
};

export const reportDataDangerousMedicineByPatient = {
  data: {
    dn: '',
    fr: true,
    pts: 1,
    rp: '',
    rpp: '/COROTA/MedicineDangerousByPat',
  },
  dataDownloadPDF: {
    dn: '',
    fmt: 2,
    pts: 0,
    rp: '',
    rpp: '/COROTA/MedicineDangerousByPat',
  },
  dataDownloadExcel: {
    dn: '',
    fmt: 3,
    pts: 0,
    rp: '',
    rpp: '/COROTA/MedicineDangerousByPat',
  },
  dataRenderReport: {
    dl: false,
    dn: '',
    fmt: 2,
    htmf: false,
    pts: 0,
    rp: '',
    rpp: '/COROTA/MedicineDangerousByPat',
    z: 100,
  },
};

export const typesDangerousMedicine = [
  { id: 0, label: 'Por medicamentos peligrosos ', name: 'dangerous-medicine' },
  { id: 0, label: 'Por pacientes afectados ', name: 'dangerous-medicine-patient', },
];
